import React, { useEffect, useState } from "react";
import axios from "axios";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Programs.css";

const NewsEventsCircular = () => {
  const [mediaData, setMediaData] = useState([]);

  useEffect(() => {
    fetchMedia();
  }, []);

  const fetchMedia = async () => {
    try {
      const res = await axios.get(
        "https://isbmuniversity.edu.in/admin-portal/mediaApi",
      );

      // latest first
      const sortedData = res.data.sort(
        (a, b) => new Date(b.date) - new Date(a.date),
      );

      setMediaData(sortedData);
    } catch (error) {
      console.error("Error fetching media:", error);
    }
  };

  // Dynamic category wise data
  const groupedData = [
    {
      title: "News Letters",
      type: "pdf",
      items: mediaData
        .filter((item) => item.category === "news_circular")
        .sort(
          (a, b) =>
            new Date(b.date?.split(" ")[0]).getTime() -
            new Date(a.date?.split(" ")[0]).getTime(),
        ),
    },
    {
      title: "Events",
      type: "event",
      items: mediaData
        .filter((item) => item.category === "events")
        .sort(
          (a, b) =>
            new Date(b.date?.split(" ")[0]).getTime() -
            new Date(a.date?.split(" ")[0]).getTime(),
        ),
    },
    {
      title: "Circulars & Notices",
      type: "pdf",
      items: mediaData
        .filter((item) => item.category === "circulars_notices")
        .sort(
          (a, b) =>
            new Date(b.date?.split(" ")[0]).getTime() -
            new Date(a.date?.split(" ")[0]).getTime(),
        ),
    },
  ];

  // PDF Slider
  const sliderSettingsPDF = {
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    autoplay: true,
    autoplaySpeed: 8000,
    arrows: true,
    pauseOnHover: true,
  };

  // Event Slider
  const sliderSettingsEvent = {
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    pauseOnHover: true,
  };

  return (
    <section className="color-section ptb-50">
      <div className="container-xxl">
        <h2 className="modern-title mb-5">
          <span>Campus Chronicles: </span>
          Latest Highlights <br />
          and Campus Updates
        </h2>

        <div className="row gy-4">
          {groupedData.map((section, idx) => (
            <div className="col-xl-4 col-md-6" key={idx}>
              <div className="program-column h-100 text-center shadow p-3 rounded-3">
                <h4 className="mb-3 py-3 text-white text-decoration-underline">
                  {section.title}
                </h4>

                <Slider
                  {...(section.type === "event"
                    ? sliderSettingsEvent
                    : sliderSettingsPDF)}
                >
                  {section.items.map((item) => (
                    <div key={item.id} className="program-item mb-2">
                      {section.type === "event" ? (
                        <div className="event-card">
                          <img
                            src={`https://isbmuniversity.edu.in/admin-server/public/uploads/media/${item.file}`}
                            alt={item.title}
                            className="event-img rounded"
                          />

                          <div className="event-info mt-3">
                            <h5 className="box-title text-white">
                              {item.title}
                            </h5>

                            <p className="text-white small mb-0">{item.date}</p>
                          </div>
                        </div>
                      ) : (
                        <a
                          href={`https://isbmuniversity.edu.in/admin-server/public/uploads/media/${item.file}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="pdf-card d-flex align-items-center border-bottom py-2 text-decoration-none"
                        >
                          <div className="pdf-icon me-2 text-purple">
                            <i className="ti ti-file fs-3"></i>
                          </div>

                          <div className="pdf-content text-start">
                            <h6 className="mb-1 text-dark">{item.title}</h6>

                            <p className="mb-0 explore-more">Explore More</p>
                          </div>
                        </a>
                      )}
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsEventsCircular;
